import "@fullcalendar/core/vdom";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from './store'
import TopMenu from "@/components/TopMenu";
import LeftMenu from "@/components/LeftMenu";
import EpiCalendar from "@/components/EpiCalendar";
import EventAddModal from "@/components/EventAddModal";
import ColorBadge from "@/components/atomics/ColorBadge";
import CustomerAddForm from "@/components/CustomerAddForm";
import EventDetailModal from "@/components/EventDetailModal";
import WorkTimeAddOffcanvas from "@/components/WorkTimeAddOffcanvas";
import VoucherEditModal from "@/components/VoucherEditModal";
import VoucherAddModal from "@/components/VoucherAddModal";
import CustomerReferrerAddModal from "@/components/CustomerReferrerAddModal";
import EpiModal from "@/components/atomics/EpiModal";
import EpiOffcanvas from "@/components/atomics/EpiOffcanvas";
import CustomerAddOffcanvas from "@/components/CustomerAddOffcanvas";
import CustomerDetailOffcanvas from "@/components/CustomerDetailOffcanvas";
import NotiSendOffcanvas from "@/components/NotiSendOffcanvas";
import EpiCard from "@/components/atomics/EpiCard";
import EpiSelect from "@/components/atomics/EpiSelect";
import EpiMultiSelect from "@/components/atomics/EpiMultiSelect";
import EpiDatePicker from "@/components/atomics/EpiDatePicker";
import DiaryAddOffcanvas from "@/components/DiaryAddOffcanvas";
import wysiwyg from "vue-wysiwyg";
import ProgramOrderEditModal from "@/components/ProgramOrderEditModal";
import EpiImageGallery from "@/components/atomics/EpiImageGallery";
import VueViewer from "v-viewer";
import { use } from "echarts/core";
import { BarChart, PieChart } from "echarts/charts";
import ECharts from "vue-echarts";
import VueSignaturePad from 'vue-signature-pad';
import 'tippy.js/dist/tippy.css'

import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
} from "echarts/components";

import { CanvasRenderer } from "echarts/renderers";
import PermissionModal from "@/components/PermissionModal";
import EpiLayout from "@/components/EpiLayout";
import EpiLayoutForCustomer from "@/components/EpiLayoutForCustomer";
import LeftMenuForCustomer from "@/components/LeftMenuForCustomer";
import TopMenuForCustomer from "@/components/TopMenuForCustomer";
import EpiMeetingPicker from "@/components/atomics/EpiMeetingPicker";
import EpiSimplyBookTitle from "@/components/atomics/EpiSimplyBookTitle";
import epiAutoCompleteInput from "@/components/atomics/EpiAutoCompleteInput";
import VueToast from 'vue-toast-notification';


// register globally


// css
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "flatpickr/dist/flatpickr.css";
import "vue-wysiwyg/dist/vueWysiwyg.css";
import "viewerjs/dist/viewer.min.css";
import "@/assets/main.css";

import 'vue-toast-notification/dist/theme-sugar.css';
import './registerServiceWorker'
import axios from "./axios.js";
Vue.prototype.$axios = axios
import VueHtml2Canvas from 'vue-html2canvas';
Vue.use(VueHtml2Canvas);
Vue.config.productionTip = false;
Vue.use(wysiwyg, {});
Vue.use(VueViewer);
import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueSimpleAlert);
import VueClipboard from 'vue-clipboard2'
import VueMobileDetection from "vue-mobile-detection";
Vue.use(VueMobileDetection);

Vue.use(VueClipboard)
// atomics
Vue.component("epi-calendar", EpiCalendar);
Vue.component("epi-modal", EpiModal);
Vue.component("epi-offcanvas", EpiOffcanvas);
Vue.component("epi-card", EpiCard);
Vue.component("epi-select", EpiSelect);
Vue.component("epi-multi-select", EpiMultiSelect);
Vue.component("epi-date-picker", EpiDatePicker);
Vue.component("epi-image-gallery", EpiImageGallery);
Vue.component("epi-auto-complete-input", epiAutoCompleteInput);
Vue.use(VueToast);
Vue.use(VueSignaturePad);
// components
Vue.component("left-menu", LeftMenu);
Vue.component("top-menu", TopMenu);
Vue.component("event-add-modal", EventAddModal);
Vue.component("color-badge", ColorBadge);
Vue.component("customer-add-form", CustomerAddForm);
Vue.component("event-detail-modal", EventDetailModal);
Vue.component("work-time-add-offcanvas", WorkTimeAddOffcanvas);
Vue.component("voucher-edit-modal", VoucherEditModal);
Vue.component("voucher-add-modal", VoucherAddModal);
Vue.component("customer-referrer-add-modal", CustomerReferrerAddModal);
Vue.component("customer-add-offcanvas", CustomerAddOffcanvas);
Vue.component("customer-detail-offcanvas", CustomerDetailOffcanvas);
Vue.component("noti-send-offcanvas", NotiSendOffcanvas);
Vue.component("diary-add-offcanvas", DiaryAddOffcanvas);
Vue.component("program-order-edit-modal", ProgramOrderEditModal);
Vue.component("permission-modal", PermissionModal);
Vue.component("epi-layout", EpiLayout);
Vue.component("epi-layout-for-customer", EpiLayoutForCustomer);
Vue.component("left-menu-for-customer", LeftMenuForCustomer);
Vue.component("top-menu-for-customer", TopMenuForCustomer);
Vue.component("epi-meeting-picker", EpiMeetingPicker);
Vue.component("epi-simply-book-title", EpiSimplyBookTitle);

// and others...
use([
  CanvasRenderer,
  BarChart,
  PieChart,
  TitleComponent,
  GridComponent,
  TooltipComponent,
  LegendComponent,
]);
Vue.component("v-chart", ECharts);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
